import gql from 'graphql-tag';

export default gql`
query GetVosUploadsByWeek($input: GetVosUploadsByWeekInput) {
  getVosUploadsByWeek(input: $input) {
    id
    name
  }
}
`;